/**
 * Default date.toISOString() function always refers to the UTC timezone
 * In some cases it is required to send the timezone based time (not the selected time in UTC time) to the backend
 * @param value
 */
export function toLocaleISOString(value: Date | string): string {
  const date = value instanceof Date ? value : new Date(value);
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
}
